export enum lettersPageActionTypes {
  SET_IS_OPEN_SAVE_AS_MODAL = 'SET_IS_OPEN_SAVE_AS_MODAL',
  SET_IS_OPEN_CHANGE_TYPE_MODAL = 'SET_IS_OPEN_SAVE_MODAL',
  SET_IS_OPEN_REASSIGN_GROUP_MODAL = 'SET_IS_OPEN_REASSIGN_GROUP_MODAL',
  SET_IS_OPEN_DELETE_MODAL = 'SET_IS_OPEN_DELETE_MODAL',
  SET_IS_OPEN_MULTIPLE_DELETE_MODAL = 'SET_IS_OPEN_MULTIPLE_DELETE_MODAL',
  SET_IS_OPEN_DOWNLOAD_MODAL = 'SET_IS_OPEN_DOWNLOAD_MODAL',
  SET_FILTERS = 'SET_FILTERS',
}
